var map = {
	"./01_create_sub_accuont.json": "Kq29",
	"./02_get_account_apiPermission.json": "m+RL",
	"./02_post_fetch_uid.json": "MZqr",
	"./03_post_fetch_sub_account_list.json": "pZuE",
	"./04_get_sub_account_spot_balance.json": "a8qg",
	"./05_create_sub_accuont_key.json": "sYD+",
	"./06_get_api_key_info.json": "azxt",
	"./07_post_edit_apikey.json": "o4h9",
	"./08_delete_sub_account_key.json": "lRf0",
	"./09_update_sub_account_status.json": "K/yH",
	"./10.post_wallet_authorize_innerTransfer.json": "JAIK",
	"./11.post_wallet_subInnerTransfer.json": "zbJw",
	"./11_post_capital_innerTransfer_apply.json": "S1Mk",
	"./12.post_wallet_createSubDepositAddress.json": "mmsx",
	"./15.get_wallet_querySubDepositAddress.json": "mcEH",
	"./16.get_wallet_querySubDepositRecords.json": "Iuwz",
	"./17.get_wallet_querySubInnerTransferRecords.json": "yVRY",
	"./18_query_sub_account_transfer_history.json": "yGUm",
	"./19_sub_account_transfer_support_coin.json": "lU9A",
	"./20_sub_account_transfer.json": "7zc5",
	"./22_sub_account_allAccountBalance.json": "mYOy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Otrz";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/common/api/subAccount \.json$
// module id = Otrz
// module chunks = 3